<template>
    <div class="prodect">
        <div class="prodect-box">
            <div class="log-input">
                <h2>统计开发日志</h2>
                <div class="prodect-name">
                    <span>产品名：</span>
                    <el-select v-model="searchParams.productId" @change="selectRecordDate()" filterable clearable placeholder="请选择"
                        size="small">
                        <el-option v-for="item in prodect_name" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="prodect-date">
                    <span>日期：</span>
                    <el-select @change="changeDate" v-model="searchParams.date" filterable clearable placeholder="请选择" size="small">
                        <el-option v-for="item in dev_date" :key="item" :label="item" :value="item">
                        </el-option>
                    </el-select>
                </div>
                <div class="prodect-btn">
                    <el-button type="primary" size="mini" @click="remove()">清空</el-button>
                </div>
            </div>

            <div class="log-main">
                <el-table :data="tableData.records" border style="width: 100%" height="100%">
                    <el-table-column prop="date" label="日期" width="120"></el-table-column>

                    <el-table-column prop="productName" label="产品名" width="200"></el-table-column>

                    <el-table-column prop="sprintName" label="迭代名称" width="200"></el-table-column>

                    <el-table-column prop="members" label="团队成员">
                        <template #default="scope">
                            <!--el-tag v-for="(member, index) in getSprintTeam(scope.row.date, scope.row.sprintId)"
                                :key="`${scope.row.sprintId}-${scope.row.date}-${index}`" size="small"
                                style="margin-right: 5px; margin-bottom: 3px;"
                                :type="isUnsubmittedMember(scope.row.date, scope.row.sprintId, member) ? 'warning' : ''">
                                {{ member.teamName }}({{ member.post }})
                            </el-tag-->

                       <el-tag v-for="(member, index) in scope.row.members"
                                :key="`${scope.row.sprintId}-${index}`" size="small"
                                style="margin-right: 5px; margin-bottom: 3px;"
                                :type="member.hasRecord ? 'success' : 'info'">
                                {{ member.name }}({{ member.post }})
                            </el-tag>

                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="100" align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="toDetail(scope.row)" type="primary">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="prodect-page">
            <!--el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 50]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination-->

            <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="tableData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>

        </div>
        <!-- ·································抽屉························································· -->
        <el-drawer title="开发日志" :visible.sync="drawer" :with-header="false" size="60%">
            <div class="drawer">
                <div class="title">
                    <h2>开发日志</h2>
                </div>
                <div class="input">
                    <div class="input-text">
                        <span>产品名：</span>
                        <el-input placeholder="产品名" v-model="detailParams.productName" :disabled="true"
                            size="medium"></el-input>
                    </div>
                    <div class="input-text">
                        <span>迭代名称：</span>
                        <el-input placeholder="迭代名称" v-model="detailParams.sprintName" :disabled="true"
                            size="medium"></el-input>
                    </div>
                    <div class="input-text">
                        <span>日期：</span>
                        <el-input placeholder="日期" v-model="detailParams.date" :disabled="true" size="medium"></el-input>
                    </div>
                    <div class="input-text">
                        <span>日志数量：</span>
                        <el-input placeholder="日志数量" v-model="detailParams.recordCount" :disabled="true" size="medium"></el-input>
                    </div>

                </div>
                <div class="team">
                    <div class="team-text">团队成员：</div>
                    <div class="team-item">
                     
                        <el-tag v-for="item in detailParams.members"
                                size="small"
                                style="margin-right: 5px; margin-bottom: 3px;"
                                :type="item.hasRecord ? 'success' : 'info'">
                                {{ item.name }}({{ item.post }})
                            </el-tag>
                    </div>

                </div>
                <div class="table">
                    <el-table :data="devRemake" border style="width: 100%" height="100%" v-loading="loadingRemake">
                        <el-table-column prop="date" label="时间" width="80">
                        </el-table-column>
                        <el-table-column prop="dbColumn_crer" label="填写" width="70">
                        </el-table-column>
                        <el-table-column prop="sprintBackLogName" label="代办名称" width="180">
                        </el-table-column>
                        <el-table-column prop="" label="消耗/总工时" width="100">
                            <template #default="scope">
                                <span>
                                    {{ scope.row.realgs }} / {{ scope.row.hopegs }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remake" label="开发日志">
                            <template slot-scope="scope">
                                <span v-html="scope.row.remake"></span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

            </div>
        </el-drawer>

    </div>
</template>

<script>
import api from '@/api/global/devlogcount/devlogcount.js'

export default {

    data() {
        return {
            //加载动画
            loadingRemake: true,

            //抽屉
            drawer: false,
            //抽屉-开发日志table内容
            teamName: [],
            devRemake: [],
            //产品名
            prodect: '',

            //日期
            date: '',

            // 产品名下拉列表
            prodect_name: [],

            //开发日志时间下拉列表
            dev_date: [],

            //表格内容回显
            tableData: {},
            recordTeams: {}, //团队成员缓存
            notRecordTeams: {},//未提交团队成员缓存

            //分页所需变量
            page: new this.$constant.pageObj(),
            searchParams:{},
            detailParams:{},//抽屉input框内容存储
        }
    },
 
    async created() {
        this.ListProdectName();
        this.selectRecordDate();
        this.list();

    },
    methods: {
         //改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},
        //获取产品名
        ListProdectName() {
            api.ListProdectName({}, res => {
                this.prodect_name = res.data;
            }, error => { });
        },
        changeDate() {
            this.current = 1;
            this.list();
        },
        //获取开发日志日期
        selectRecordDate() {
            this.date = '';

            api.ListRecordDate({
                productId: this.searchParams.productId
            }, res => {
                this.dev_date = res.data;
                this.list();
            }, error => { });


        },
        //统计开发日志提交数量
        list() {

        	let params = this.$utils.merger(this.searchParams, this.page);

            api.selectRecordRemark(params, res => {
                this.tableData =  res.data;
            }, error => { })

        },
        
        //去详情
        toDetail(row) {
            this.detailParams = row;
            this.loadingRemake = true;
            this.drawer = true;
            this.teamName = [];

            api.toDetail({
                sprId: row.sprintId,
                date: row.date
            }, res => {
                this.devRemake = res.data;
                this.loadingRemake = false;
            }, error => { })

        },
        //清空选项并刷新
        remove() {
            this.searchParams ={}
            this.dev_date = [];
            this.selectRecordDate();
        }
    }
}


</script>

<style scoped>
.prodect {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .prodect-box {
        height: 90%;

        .log-input {
            height: 10%;
            display: flex;
            align-items: center;

            .prodect-name {
                margin: 0px 10px;
            }

            .prodect-date {
                margin: 0px 10px;
            }

            .prodect-btn {
                margin: 0px 10px;
            }

            h2 {
                margin: 0px 50px;
            }
        }

        .log-main {
            height: 90%;
            margin-top: 10px;
        }
    }

    .prodect-page {
        height: 5%;
    }
}

.drawer {
    width: 95%;
    height: 100%;
    margin: auto;

    .title {
        height: 7%;
        display: flex;
        align-items: center;
    }

    .input {
        height: 12%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-direction: row;
        flex-wrap: wrap;

        span {
            width: 125px;
            margin-left: 10px;
            text-align: center;

        }

        .input-text {
            width: 50%;
            display: flex;
            align-items: center;
        }

    }

    .team {
        height: 5%;
        display: flex;
        align-items: center;
        margin: 5px 0;

        .team-text {
            height: 100%;
            width: 10%;
            display: flex;
            align-items: center;
        }

        .team-item {
            height: 100%;
            width: 85%;
            display: flex;
            flex-direction: row;
            align-items: center;
            flex-wrap: wrap;
        }

    }

    .table {
        height: 70%;
    }

}
</style>